import React, { useState } from 'react'
import { append, uniq } from 'ramda'

import './style.scss'

const WEEKDAYS = ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA']

export default function ReactRRuleInput({ currentValue, inputName, allowedOptions, selectedOptions, errors }) {
  const getDaysArray = string =>
    string
      ?.replace(/(.*)BYDAY=/, '')
      .split(',')
      .filter(element => element !== '')

  const permittedOptions = getDaysArray(allowedOptions) || []
  const disabledDays = getDaysArray(selectedOptions) || []
  const [selectedDays, setSelectedDays] = useState(
    getDaysArray(currentValue)?.filter(day => !disabledDays.includes(day)) || []
  )
  const handleOnChange = value => {
    if (selectedDays.includes(value)) {
      setSelectedDays(selectedDays.filter(x => x !== value))
    } else {
      setSelectedDays(uniq(append(value, selectedDays)))
    }
  }

  const Error = ({ error }) => {
    return <p className='inline-errors my-2'>{error}</p>
  }

  return (
    <div className='schedule d-inline-block'>
      {WEEKDAYS.map(day => (
        <label
          key={day}
          className={`day-box cursor-pointer ${!permittedOptions.includes(day) && 'bg-grey'} ${
            disabledDays.includes(day) && 'bg-yellow'
          } ${day}-day`}
          htmlFor={`${day}-${inputName}`}
        >
          <label htmlFor={`${day}-${inputName}`} className='checkbox-custom-title flex-grow-1 mb-2 my-auto text-body'>
            {day}
          </label>
          <label className='checkbox-label flex-shrink-1'>
            <input
              id={`${day}-${inputName}`}
              type='checkbox'
              className='wday'
              checked={selectedDays.includes(day)}
              onChange={() => handleOnChange(day)}
              disabled={!permittedOptions.includes(day) || disabledDays.includes(day)}
            />
            <span className='checkbox-custom rectangular' />
          </label>
        </label>
      ))}
      {errors && <Error error={errors} />}
      <input
        name={inputName}
        className='form-control'
        type='hidden'
        value={selectedDays.length > 0 ? `RRULE:FREQ=WEEKLY;INTERVAL=1;BYDAY=${selectedDays}` : ''}
      />
    </div>
  )
}
